/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_PhoneInputs */



/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Profile_PhoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_phone = /** @type {((inputs?: Profile_PhoneInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_PhoneInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Téléphone")
	if (locale === "es") return /** @type {LocalizedString} */ ("Teléfono")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Telefone")
	if (locale === "it") return /** @type {LocalizedString} */ ("Telefono")
	return /** @type {LocalizedString} */ ("Phone")
});